import React, { useState } from 'react';
import HomeSearch from '../../components/home/HomeSearch';
import { Icon } from '@iconify/react/dist/iconify.js';
import '../../Assets/CSS/banner.css';
import BannerCarousel from '../../components/home/BannerCarousel';
import ImageCarousel from '../../components/home/ImageCarousel';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import axios from 'axios'; // Import axios
import Login from '../../components/auth/login/Login';
import toast, { Toaster } from 'react-hot-toast';
import { getCookie } from '../../components/auth/login/GetCookie';

const Banner = ({isAuthenticated}) => {
    const [hovered, setHovered] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [loadingExploreMore, setLoadingExploreMore] = useState(false);
    const navigate = useNavigate(); // Initialize useNavigate for navigation

   // const token = localStorage.getItem("token");
   const token = getCookie("token");
    const handleCloseLogin = () => {
        // Close login modal
        setShowLoginModal(false);

    }
    const handleExploreMore = async () => {   
        
        if (!isAuthenticated) {
            setShowLoginModal(true);
            return;
        }
             
        try {
            setLoadingExploreMore(true)
            // Call the API to fetch product data
           // const token = localStorage.getItem("token"); // Retrieve token from localStorage
           const token = getCookie("token");

                const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/search`,
                {
                    headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`, // Include Bearer token
                    },
                }
                );

            // Navigate to the product list page with the response data
            setLoadingExploreMore(false)
            navigate('/productlist', { state: { results: response.data } });

        } catch (error) {
            console.error("Error fetching product data:", error);
            alert("Failed to load products. Please try again later.");
        }
    };
        

    return (
        <div className="container-fluid home">
                                {showLoginModal && (<Login onClose={handleCloseLogin} loginopen={showLoginModal} />
            )}
            <Toaster position='top-right' reverseOrder={false}/>
            <div className=''>
                <HomeSearch  isAuthenticated={isAuthenticated}/> 
                    <div className='col-lg-12 py-md-3 d-flex flex-wrap justify-content-center align-items-left'>
                        <div className='col-md-6 col-12'>
                            <div className='mb-3  px-3 text-lg-start'>
                                <h1 className='heading-home mt-lg-5 mt-md-3 mt-sm-0 py-sm-0 py-lg-3  '>
                                    Lorem ipsum dolor sit amet, <br />consectetur adipiscing elit
                                </h1>
                                {/* #38cd2b */}
                                {/* <button
                                    className=" explore-btn rounded-pill px-3 mt-2 py-2 fs-6 fw-semibold"
                                    style={{
                                        fontSize: '18px',
                                        border: '0.5px solid #5E6B49',
                                        backgroundColor: hovered ? '#5E6B49' : 'white',
                                        color: hovered ? 'white' : '#5E6B49',
                                    }}
                                    onMouseEnter={() => setHovered(true)}
                                    onMouseLeave={() => setHovered(false)}
                                    onClick={ () =>  {
                                        handleExploreMore()
                                    }} // Trigger the API call and navigate on click
                                >
                                    Explore more
                                    <Icon
                                        icon={hovered ? "octicon:arrow-down-24" : "octicon:arrow-right-24"}
                                        className='ms-1'
                                    />
                                </button> */}
                                    <button
            className="explore-btn rounded-pill px-3 mt-2 py-2 fs-6 fw-semibold"
            style={{
                fontSize: "18px",
                border: "0.5px solid #371300",
                backgroundColor: hovered ? "#371300" : "#FFFFFF99",
                color: hovered ? "white" : "#371300",
                cursor: loadingExploreMore ? "not-allowed" : "pointer",
                opacity: loadingExploreMore ? 0.7 : 1,
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={handleExploreMore}
            disabled={loadingExploreMore}
        >
            {loadingExploreMore ? "Processing..." : "Explore more"}
            <Icon
                icon={loadingExploreMore ? "eos-icons:loading" : hovered ? "octicon:arrow-down-24" : "octicon:arrow-right-24"}
                className="ms-1"
            />
        </button>
                            
                            </div>
                        </div>  
                        <div className='col-md-6 col-lg-6 col-12'>
                            <BannerCarousel  {...{ isAuthenticated }}/>
                        </div>
                        <ImageCarousel  {...{ isAuthenticated }}/>
                    </div>
            </div>
        </div>
    );
};

export default Banner;
